import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { BLACK_FRIDAY_TEASER_IMG, isBlackFridayTeaserActive } from "@/data/blackFridayTeaser";

const KEY = "bf2026_mobile_splash_seen";

// Nov 3 2026 · Karine — on mobile, show the Black Friday poster for 5 seconds the
// first time a client lands on the homepage this session, then slide it away.
export default function BlackFridayMobileSplash() {
  const [show, setShow] = useState(false);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    if (!isBlackFridayTeaserActive()) return;
    if (typeof window === "undefined" || window.innerWidth >= 768) return;
    try { if (sessionStorage.getItem(KEY)) return; sessionStorage.setItem(KEY, "1"); } catch { /* private mode */ }
    setShow(true);
  }, []);

  useEffect(() => {
    if (!show) return;
    const t1 = setTimeout(() => setLeaving(true), 5000);
    const t2 = setTimeout(() => setShow(false), 5600);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [show]);

  if (!show) return null;
  const close = () => { setLeaving(true); setTimeout(() => setShow(false), 450); };
  return (
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center p-6 md:hidden"
      style={{ background: "rgba(0,0,0,0.78)", backdropFilter: "blur(6px)", transition: "opacity .45s ease", opacity: leaving ? 0 : 1 }}
      onClick={close}
      role="dialog"
      aria-label="Black Friday is coming"
      data-testid="bf-mobile-splash"
    >
      <div
        className="relative w-full max-w-sm"
        style={{ transform: leaving ? "translateY(24px) scale(.96)" : "translateY(0) scale(1)", transition: "transform .45s ease" }}
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" onClick={close} aria-label="Close" className="absolute -top-3 -right-3 z-10 w-9 h-9 rounded-full bg-[#dfc06e] text-black flex items-center justify-center shadow-lg" data-testid="bf-mobile-splash-close">
          <X className="w-5 h-5" />
        </button>
        <Link to="/promotions#black-friday" onClick={close} data-testid="bf-mobile-splash-link">
          <img src={BLACK_FRIDAY_TEASER_IMG} alt="Black Friday is coming — Friday, November 27 — stay tuned" className="w-full h-auto rounded-2xl ring-2 ring-[#dfc06e]/70 shadow-2xl" />
        </Link>
        <p className="mt-3 text-center text-[11px] uppercase tracking-[0.25em] text-[#dfc06e] font-black">Tap to get the deals first</p>
        <div className="mt-2 h-0.5 w-full rounded bg-white/15 overflow-hidden">
          <div className="h-full bg-[#dfc06e]" style={{ animation: "bfSplashBar 5s linear forwards" }} />
        </div>
        <style>{`@keyframes bfSplashBar { from { width: 100%; } to { width: 0%; } }`}</style>
      </div>
    </div>
  );
}
